module.exports = true;



//////////////////
// WEBPACK FOOTER
// /home/deploy/gamba/shared/rnclient/node_modules/core-js/library/modules/_library.js
// module id = 284
// module chunks = 4